<template>
  <div
    class="ll-link-list"
    :class="{borderTop:borderTop}"
    :style="{marginTop:marginTop + 'px'}"
  >
    <p
      v-if="title"
      class="ll-link-list_title"
    >
      {{ $t(title) }}
    </p>
    <div class="ll-link-list_content">
      <LlLink
        v-for="(link_e,link_k) in _linkList"
        :key="link_k"
        :text-label="link_e.textLabel ? link_e.textLabel : link_e.title ? link_e.title : ''"
        @click="$_onClick(link_e)"
      />
    </div>
    <div
      v-if="_hasHide"
      class="ll-link-list_collapse-btn"
    >
      <WsTextButton001
        v-if="active"
        leading-icon="icon-chevron-up"
        primary
        no-padding
        @click="$_collapseClose()"
      >
        {{ $t(hideText) }}
      </WsTextButton001>
      <WsTextButton001
        v-else
        leading-icon="icon-chevron-down"
        primary
        no-padding
        @click="$_collapseOpen()"
      >
        {{ $t(showText) }}
      </WsTextButton001>
    </div>
  </div>
</template>
<script>
export default {
  name: "LlLinkList",
  props: {
    linkList: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: "",
    },
    borderTop: {
      type: Boolean,
      default: false,
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    hideLength: {
      type: Number,
      default: 6,
    },
    showText: {
      type: String,
      default() {
        return this.$t("展開");
      },
    },
    hideText: {
      type: String,
      default() {
        return this.$t("收起");
      },
    },
    hasHide: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    active: false,
  }),
  computed: {
    _linkList() {
      if (this.hasHide && !this.active) {
        const list = this.linkList.filter((item, itemIndex) => {
          return itemIndex < this.hideLength;
        });
        return list;
      }
      return this.linkList;
    },
    _hasHide() {
      if (this.hasHide && this.linkList.length > this.hideLength) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    $_onClick(link) {
      this.$emit("click", link);
    },
    $_collapseOpen() {
      this.active = true;
    },
    $_collapseClose() {
      this.active = false;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-link-list";
</style>